import React, { useEffect, useState } from "react";
import { Divider } from "@material-ui/core";
import { useDataProvider } from "../../api/DataProvider";
import "../../styles/devices/mob_SignDialog.css";
import ReactPlayer from "react-player";
import Button from "@mui/material/Button";
import { pDataProvider } from "../../utils/parameters";
import SendIcon from "@mui/icons-material/Send";
import BackspaceIcon from "@mui/icons-material/Backspace";
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import device from "current-device";
import { useCommProvider } from "../../api/CommProvider";
import { useTranslation } from "react-i18next";
import { DeviceQueries } from "../utils/DeviceQueries";


export default function DialogContentSendFeedback(props) {
  const { dialogPosition, handleClickConfirmSendFeedback, handleClickCancelSendFeedback } = props;
  const { t } = useTranslation("global")

  const { json_data_lemma, json_data_meaning, comm_getPublicURLVideoData } = useDataProvider();
  // const { comm_getPublicURLVideoData } = useCommProvider();
  const [url_vid, set_url_vid] = useState();
  const [gloss, setGloss] = useState();

  /* MOB - Nav responsiveness */
  const queryMatches = DeviceQueries();

  /* MOB - Set event listener to be able to update the values of the queryMatches that use 'device.orientation' data */
  useEffect(() => {
    
    if (dialogPosition["gloss"] !== undefined) {
      set_url_vid(comm_getPublicURLVideoData(pDataProvider.dir_vid_sign, dialogPosition["gloss"]))
      setGloss(dialogPosition["gloss"]);
    }else{
      set_url_vid(null)
      setGloss(pDataProvider.new_sign);
    }

    // console.log('DIALOG CONTENT SEND FEEDBACK')

  }, []);


  return (
    <>    
      {dialogPosition["gloss"] !== undefined && queryMatches.deviceLandscape ? 
        <>
           <ReactPlayer className="sig_SignModalPaperVideo" width="100%" height="auto" progressInterval={2000} url={url_vid} loop={true} pip={true} muted={true} controls={true} playing={true} />
        </> 
      : <></> }
      <div className="sig_SignModal_SendFeedbackContainer">
        <Paper className="sig_SignModal_PaperContent">
          <div className="sig_SignModal_PaperTitle"> {t("sDialog.resumen").toUpperCase()} </div>

          <Divider className="sig_SignModal_DefinitionDivider sig_Home_RemovableElement" />

          <div className='sig_SignModal_PaperLine'>
            <div className="sig_SignModal_PaperTitle sig_SignModal_Paper_Title_Body_Inline">{t("sDialog.word")}:</div>
            <div className="sig_SignModal_PaperBody">{json_data_lemma[dialogPosition["lemma"]]["label"]}</div>
          </div>
          <div className='sig_SignModal_PaperLine'>
              <span className="sig_SignModal_PaperTitle sig_SignModal_Paper_Title_Body_Inline"> {t("sDialog.defTab")}:</span>
              <span className="sig_SignModal_PaperBodyInline">{json_data_meaning[dialogPosition["meaning"]]["definition"]}</span>
          </div>
          {dialogPosition["gloss"] !== undefined ? (
            <>
              <div className='sig_SignModal_PaperLine'>
                <div className="sig_SignModal_PaperTitle sig_SignModal_Paper_Title_Body_Inline"> {t("sDialog.signTab")}:</div>
                {/* <div className="sig_SignModal_PaperBody">{dialogPosition["gloss"]}</div> */}
              </div>
            </>
          ) : (
            <>
              <div className='sig_SignModal_PaperLine'>
                <div className="sig_SignModal_PaperTitle sig_SignModal_Paper_Title_Body_Inline"> {t("sDialog.signTab")}:</div>
                <div className="sig_SignModal_PaperBody"> {t("sDialog.no_registred_new_variant")} </div>            
              </div>
            </>
          )}
        </Paper>      
        {dialogPosition["gloss"] !== undefined && !queryMatches.deviceLandscape ? 
          <>
            <ReactPlayer className="sig_SignModalPaperVideo" width="100%" height="auto" progressInterval={2000} url={url_vid} loop={true} pip={true} muted={true} controls={true} playing={true} />
          </> 
        : <></> }
        <div className="sig_SignDialog_FeedbackOptions">
          <Divider className="sig_SignModal_DefinitionDivider sig_Home_RemovableElement" />
          <Button className="sig_SignDialog_Button" endIcon={<SendIcon />} onClick={handleClickConfirmSendFeedback}>
            {dialogPosition["gloss"] !== undefined ? t("sDialog.confirmFeedback") : t("sDialog.confirmFeedbackNew")}
          </Button>
          <Divider className="sig_SignModal_DefinitionDivider sig_Home_RemovableElement" />
          <Button className="sig_SignDialog_Button" endIcon={<BackspaceIcon />} onClick={handleClickCancelSendFeedback}>
            {t("sDialog.cancelFeedback")}
          </Button>
        </div>
      </div>
    </>
  );
}
